import React, {useEffect, useState} from 'react'
import {CopyLinkContainer} from './styled'
import {ParagraphText, Checkbox, Button, Icon, Radio} from '@thryvlabs/maverick'
import {useFlags} from 'launchdarkly-react-client-sdk'
import {LinkPrompt} from './ui/payment-details'
import {toast} from 'react-toastify'
import {useUserRoles} from '../utils/use-user-roles'
import {useUserFeatures} from '../context/user-features-context'

const PaymentLink = ({
  contactMethod,
  setContactMethod,
  mobile,
  email,
  currentPrice,
  totalCcPrice,
  totalPrice,
  bypassSms,
  hasAppliedCoupons,
  setBypassSms,
  isLinkSent,
  handlePartnerOpsGenerateLink,
  handleSendLink,
  handleResendLink,
  sendLinkError,
  shortenedUrl,
  children,
  is5Order,
  partnerOpsGeneratedUrl,
  isAppointmentExpired,
}) => {
  const {roles} = useUserRoles()
  const {frontendTssLinkBypass} = useFlags()
  const userFeatures = useUserFeatures()
  const showCopyLinkButton = !!userFeatures?.Payment_Link_Copy_Button

  const [linkCopied, setLinkCopied] = useState(false)

  const handleCopyToClipBoard = () => {
    navigator.clipboard.writeText(shortenedUrl)
    setLinkCopied(true)
    toast.success('Link copied.')
    setTimeout(() => setLinkCopied(false), 2000)
  }

  const handleContactMethodChange = e => {
    setContactMethod(e.target.value)
  }

  // useEffect(() => {
  //   if (frontendSendLinkVia === 'choice') {
  //     // setContactMethod('sms')
  //     setContactMethod('email')
  //     return
  //   }
  //   setContactMethod(frontendSendLinkVia)
  // }, [frontendSendLinkVia, setContactMethod])

  const [copyClicked, setCopyClicked] = useState(false)

  const handleCopyLinkToClipBoard = () => {
    navigator.clipboard.writeText(partnerOpsGeneratedUrl)
    setCopyClicked(true)
    setTimeout(() => {
      setCopyClicked(false)
    }, 4000)
    toast.success('Link copied.')
  }

  useEffect(() => {
    if (partnerOpsGeneratedUrl) {
      handleCopyLinkToClipBoard()
    }
  }, [partnerOpsGeneratedUrl])

  const displayedMethod = contactMethod === 'sms' ? 'SMS' : contactMethod

  // Bypass is only allowed when:
  // 1. Current price is $0 or matches total price, AND
  // 2. No coupons/discounts are applied (to prevent bypassing ratable items made free via coupon)
  const isLinkBypassCheckboxVisible =
    ((totalCcPrice && currentPrice >= totalCcPrice) ||
      (totalPrice && currentPrice >= parseFloat(totalPrice))) &&
    !hasAppliedCoupons

  if (roles.includes('PartnerOps') && is5Order) {
    return (
      <div>
        <CopyLinkContainer>
          {/* <p className="mb-1">Generated Link</p> */}
          {!partnerOpsGeneratedUrl && (
            <button
              onClick={handlePartnerOpsGenerateLink}
              className={
                partnerOpsGeneratedUrl ? 'btn-genurl-disabled' : 'btn-genurl'
              }
            >
              {'Generate Link'}
            </button>
          )}
          {partnerOpsGeneratedUrl && (
            <div className="d-flex justify-content-start align-items-center url-wrapper">
              <div className="g-url">{partnerOpsGeneratedUrl}</div>
              <button
                onClick={handleCopyLinkToClipBoard}
                className="btn-gurl"
                style={{
                  backgroundColor: copyClicked ? '#056e3021' : '#eaeaea',
                  color: copyClicked ? '#056e30' : 'black',
                  border: copyClicked ? '1px solid #00b34b' : 'none',
                  borderRadius: copyClicked ? '0 4px 4px 0' : 'none',
                  fontWeight: copyClicked ? 'bold' : 'normal',
                  transition: 'background-color 0.4s, color 0.4s',
                }}
              >
                {copyClicked ? 'Copied!' : 'Copy'}
              </button>
            </div>
          )}
        </CopyLinkContainer>
      </div>
    )
  } else {
    return (
      <div>
        {children}
        <ParagraphText variant="reg" className="mb-1">
          The payment link will be sent via {displayedMethod} to
        </ParagraphText>
        <ParagraphText variant="reg" className="font-weight-bold">
          {contactMethod === 'sms' ? mobile : email}
        </ParagraphText>
        <div className="d-flex gap-3">
          <Radio
            hasLabel
            id="sms"
            name="contactMethods"
            value="sms"
            label="SMS"
            toggled={contactMethod === 'sms'}
            handleOnChange={handleContactMethodChange}
          />
          <Radio
            hasLabel
            id="email"
            name="contactMethods"
            value="email"
            label="email"
            toggled={contactMethod === 'email'}
            handleOnChange={handleContactMethodChange}
          />
        </div>
        {frontendTssLinkBypass && !!isLinkBypassCheckboxVisible && (
          <Checkbox
            hasLabel
            name="bypassNumber"
            label="Bypass sending Payment Link"
            isChecked={bypassSms}
            onChange={() => setBypassSms(!bypassSms)}
          />
        )}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginTop: '1rem',
            flexWrap: 'wrap',
          }}
        >
          {isLinkSent && !bypassSms ? (
            <Button
              variant="primary"
              type="button"
              onClick={handleResendLink}
              disabled={isAppointmentExpired}
            >
              Send Again
            </Button>
          ) : (
            <Button variant="primary" type="button" onClick={handleSendLink}>
              {bypassSms ? 'Process Order' : 'Send Link'}
            </Button>
          )}
          {shortenedUrl && showCopyLinkButton && (
            <button
              type="button"
              onClick={handleCopyToClipBoard}
              aria-label={
                linkCopied
                  ? 'Payment link copied to clipboard'
                  : 'Copy payment link to clipboard'
              }
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                padding: '10px 14px',
                background: 'transparent',
                border: linkCopied ? '1px solid #FF5000' : '1px solid #d0d0d0',
                borderRadius: '4px',
                color: linkCopied ? '#FF5000' : '#231f20',
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: 1,
                cursor: 'pointer',
                transition: 'color .2s, border-color .2s, background .2s',
              }}
              onMouseEnter={e => {
                if (!linkCopied) {
                  e.currentTarget.style.background = '#f5f5f5'
                  e.currentTarget.style.borderColor = '#b0b0b0'
                }
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = 'transparent'
                e.currentTarget.style.borderColor = linkCopied
                  ? '#FF5000'
                  : '#d0d0d0'
              }}
            >
              <Icon
                type="solid"
                variant={linkCopied ? 'check' : 'link'}
                color={linkCopied ? '#FF5000' : 'currentColor'}
                height="14"
                width="14"
              />
              <span>{linkCopied ? 'Copied!' : 'Copy Link'}</span>
            </button>
          )}
        </div>
        {!bypassSms && (isLinkSent || sendLinkError) && (
          <LinkPrompt success={!sendLinkError}>
            <div style={{margin: '5px 8px 0 0'}}>
              <Icon
                variant="infoCircle"
                type="regular"
                color={!sendLinkError ? '#057AFF' : '#DF2A2A'}
                height="16"
                width="16"
              />
            </div>
            <ParagraphText
              variant="reg"
              className="m-0"
              style={{width: '292px'}}
            >
              {!sendLinkError
                ? 'Thryv has sent you a payment link. Click the link to review order, enter payment and agree to the terms.'
                : 'Failed to send payment link. Click Resend to try again.'}
            </ParagraphText>
          </LinkPrompt>
        )}
      </div>
    )
  }
}

export default PaymentLink
